import { render, staticRenderFns } from "./indexPage.vue?vue&type=template&id=4ff4e421&scoped=true&"
import script from "./indexPage.vue?vue&type=script&lang=js&"
export * from "./indexPage.vue?vue&type=script&lang=js&"
import style0 from "./indexPage.vue?vue&type=style&index=0&id=4ff4e421&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ff4e421",
  null
  
)

export default component.exports